// SHADOW MARKET™ — Patrón Gráfico SVG renderer.
// Each diagram lives in a 260×148 viewBox and uses the Academy palette
// (orange/amber accents, cyan structure lines, green/red direction).
import React from "react";

const SVGS = {
  "bandera-alcista": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <line x1="0" y1="74" x2="260" y2="74" stroke="#1c2240" stroke-width=".3" opacity=".25"/>
    <polyline points="20,125 65,35" fill="none" stroke="#00d4ff" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="65" y1="35" x2="140" y2="65" stroke="#f5a623" stroke-width="1.5"/>
    <line x1="75" y1="52" x2="150" y2="82" stroke="#f5a623" stroke-width="1.5"/>
    <polyline points="65,42 82,55 98,48 115,60 130,54 140,65" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="140" y1="65" x2="200" y2="22" stroke="#00e676" stroke-width="2"/>
    <polygon points="200,22 193,32 206,30" fill="#00e676"/>
    <line x1="140" y1="18" x2="250" y2="18" stroke="#00e676" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <circle cx="250" cy="18" r="2.5" fill="#00e676" opacity=".8"/>
    <text x="243" y="14" fill="#00e676" font-family="monospace" font-size="7" text-anchor="middle">OBJ</text>
    <text x="42" y="88" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">ASTA</text>
    <text x="105" y="100" fill="#f5a623" font-family="monospace" font-size="7" text-anchor="middle">BANDERA</text>`,

  "bandera-bajista": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="20,25 65,115" fill="none" stroke="#00d4ff" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="55" y1="98" x2="135" y2="68" stroke="#f5a623" stroke-width="1.5"/>
    <line x1="65" y1="115" x2="145" y2="85" stroke="#f5a623" stroke-width="1.5"/>
    <polyline points="65,115 80,102 97,108 112,95 128,100 140,85" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="140" y1="85" x2="195" y2="132" stroke="#ff3355" stroke-width="2"/>
    <polygon points="195,132 185,124 192,122" fill="#ff3355"/>
    <line x1="140" y1="135" x2="250" y2="135" stroke="#ff3355" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <circle cx="250" cy="135" r="2.5" fill="#ff3355" opacity=".8"/>
    <text x="243" y="131" fill="#ff3355" font-family="monospace" font-size="7" text-anchor="middle">OBJ</text>
    <text x="42" y="65" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">ASTA</text>
    <text x="105" y="62" fill="#f5a623" font-family="monospace" font-size="7" text-anchor="middle">BANDERA</text>`,

  "banderin-alcista": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="20,125 65,30" fill="none" stroke="#00d4ff" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="65" y1="30" x2="135" y2="58" stroke="#f5a623" stroke-width="1.5"/>
    <line x1="65" y1="55" x2="135" y2="58" stroke="#f5a623" stroke-width="1.5"/>
    <polyline points="65,40 80,50 95,45 110,52 125,50 135,58" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="135" y1="58" x2="192" y2="18" stroke="#00e676" stroke-width="2"/>
    <polygon points="192,18 184,28 196,26" fill="#00e676"/>
    <line x1="135" y1="14" x2="250" y2="14" stroke="#00e676" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <circle cx="250" cy="14" r="2.5" fill="#00e676" opacity=".8"/>
    <text x="243" y="10" fill="#00e676" font-family="monospace" font-size="7" text-anchor="middle">OBJ</text>
    <text x="42" y="85" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">ASTA</text>
    <text x="100" y="78" fill="#f5a623" font-family="monospace" font-size="7" text-anchor="middle">BANDERÍN</text>`,

  "banderin-bajista": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="20,25 65,120" fill="none" stroke="#00d4ff" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="65" y1="98" x2="135" y2="92" stroke="#f5a623" stroke-width="1.5"/>
    <line x1="65" y1="120" x2="135" y2="92" stroke="#f5a623" stroke-width="1.5"/>
    <polyline points="65,110 80,100 95,108 110,96 125,100 135,92" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="135" y1="92" x2="192" y2="132" stroke="#ff3355" stroke-width="2"/>
    <polygon points="192,132 182,124 190,122" fill="#ff3355"/>
    <line x1="135" y1="135" x2="250" y2="135" stroke="#ff3355" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <circle cx="250" cy="135" r="2.5" fill="#ff3355" opacity=".8"/>
    <text x="243" y="131" fill="#ff3355" font-family="monospace" font-size="7" text-anchor="middle">OBJ</text>
    <text x="42" y="65" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">ASTA</text>
    <text x="100" y="70" fill="#f5a623" font-family="monospace" font-size="7" text-anchor="middle">BANDERÍN</text>`,

  "taza-asa": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="10,80 30,50" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M30,50 C60,125 130,125 162,50" fill="none" stroke="#00d4ff" stroke-width="2"/>
    <line x1="30" y1="50" x2="210" y2="50" stroke="#00d4ff" stroke-width="1" stroke-dasharray="5,3" opacity=".6"/>
    <polyline points="162,50 175,65 185,60 196,50" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="196" y1="50" x2="242" y2="18" stroke="#00e676" stroke-width="2"/>
    <polygon points="242,18 234,28 246,26" fill="#00e676"/>
    <text x="97" y="118" fill="#00d4ff" font-family="monospace" font-size="8" text-anchor="middle">TAZA</text>
    <text x="178" y="80" fill="#6a7a8a" font-family="monospace" font-size="7" text-anchor="middle">ASA</text>`,

  "taza-asa-invertida": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="10,70 30,100" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M30,100 C60,25 130,25 162,100" fill="none" stroke="#00d4ff" stroke-width="2"/>
    <line x1="30" y1="100" x2="210" y2="100" stroke="#00d4ff" stroke-width="1" stroke-dasharray="5,3" opacity=".6"/>
    <polyline points="162,100 175,85 185,90 196,100" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="196" y1="100" x2="242" y2="132" stroke="#ff3355" stroke-width="2"/>
    <polygon points="242,132 232,124 240,122" fill="#ff3355"/>
    <text x="97" y="35" fill="#00d4ff" font-family="monospace" font-size="8" text-anchor="middle">TAZA INV.</text>
    <text x="178" y="72" fill="#6a7a8a" font-family="monospace" font-size="7" text-anchor="middle">ASA</text>`,

  "doble-techo": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="15,110 40,35 75,80 110,35 145,82 175,118 200,132" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="15" y1="80" x2="215" y2="80" stroke="#00d4ff" stroke-width="1.5" stroke-dasharray="6,3"/>
    <circle cx="40" cy="35" r="3" fill="#ff3355"/>
    <circle cx="110" cy="35" r="3" fill="#ff3355"/>
    <line x1="175" y1="118" x2="205" y2="136" stroke="#ff3355" stroke-width="2"/>
    <polygon points="205,136 196,128 204,126" fill="#ff3355"/>
    <line x1="175" y1="132" x2="250" y2="132" stroke="#ff3355" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <circle cx="250" cy="132" r="2.5" fill="#ff3355" opacity=".8"/>
    <text x="75" y="25" fill="#ff3355" font-family="monospace" font-size="7" text-anchor="middle">DOBLE TECHO</text>
    <text x="165" y="93" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">CUELLO</text>`,

  "doble-suelo": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="15,40 40,115 75,70 110,115 145,68 175,35 200,18" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="15" y1="70" x2="215" y2="70" stroke="#00d4ff" stroke-width="1.5" stroke-dasharray="6,3"/>
    <circle cx="40" cy="115" r="3" fill="#00e676"/>
    <circle cx="110" cy="115" r="3" fill="#00e676"/>
    <line x1="175" y1="35" x2="205" y2="14" stroke="#00e676" stroke-width="2"/>
    <polygon points="205,14 196,24 208,22" fill="#00e676"/>
    <line x1="175" y1="16" x2="250" y2="16" stroke="#00e676" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <circle cx="250" cy="16" r="2.5" fill="#00e676" opacity=".8"/>
    <text x="75" y="128" fill="#00e676" font-family="monospace" font-size="7" text-anchor="middle">DOBLE SUELO</text>
    <text x="165" y="62" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">CUELLO</text>`,

  "triple-techo": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="10,105 28,35 52,78 70,35 95,78 113,35 138,80 165,118 185,130" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="10" y1="78" x2="200" y2="78" stroke="#00d4ff" stroke-width="1.5" stroke-dasharray="6,3"/>
    <circle cx="28" cy="35" r="2.5" fill="#ff3355"/>
    <circle cx="70" cy="35" r="2.5" fill="#ff3355"/>
    <circle cx="113" cy="35" r="2.5" fill="#ff3355"/>
    <line x1="165" y1="118" x2="195" y2="136" stroke="#ff3355" stroke-width="2"/>
    <polygon points="195,136 186,128 194,126" fill="#ff3355"/>
    <line x1="162" y1="132" x2="250" y2="132" stroke="#ff3355" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <text x="70" y="25" fill="#ff3355" font-family="monospace" font-size="7" text-anchor="middle">TRIPLE TECHO</text>
    <text x="165" y="70" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">CUELLO</text>`,

  "triple-suelo": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="10,42 28,112 52,68 70,112 95,68 113,112 138,68 165,32 185,18" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="10" y1="68" x2="200" y2="68" stroke="#00d4ff" stroke-width="1.5" stroke-dasharray="6,3"/>
    <circle cx="28" cy="112" r="2.5" fill="#00e676"/>
    <circle cx="70" cy="112" r="2.5" fill="#00e676"/>
    <circle cx="113" cy="112" r="2.5" fill="#00e676"/>
    <line x1="165" y1="32" x2="195" y2="12" stroke="#00e676" stroke-width="2"/>
    <polygon points="195,12 186,22 198,20" fill="#00e676"/>
    <line x1="162" y1="14" x2="250" y2="14" stroke="#00e676" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <text x="70" y="126" fill="#00e676" font-family="monospace" font-size="7" text-anchor="middle">TRIPLE SUELO</text>
    <text x="165" y="60" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">CUELLO</text>`,

  "cabeza-hombros": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="10,105 32,58 55,90 85,22 115,90 138,58 162,102 190,125 215,135" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="55" y1="90" x2="215" y2="96" stroke="#00d4ff" stroke-width="1.5" stroke-dasharray="6,3"/>
    <circle cx="85" cy="22" r="3.5" fill="#ff3355"/>
    <circle cx="32" cy="58" r="2.5" fill="#ff3355" opacity=".7"/>
    <circle cx="138" cy="58" r="2.5" fill="#ff3355" opacity=".7"/>
    <line x1="190" y1="125" x2="218" y2="138" stroke="#ff3355" stroke-width="2"/>
    <polygon points="218,138 210,130 218,128" fill="#ff3355"/>
    <line x1="188" y1="136" x2="252" y2="136" stroke="#ff3355" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <text x="85" y="13" fill="#ff3355" font-family="monospace" font-size="7" text-anchor="middle">CABEZA</text>
    <text x="32" y="48" fill="#6a7a8a" font-family="monospace" font-size="6" text-anchor="middle">H.IZQ</text>
    <text x="138" y="48" fill="#6a7a8a" font-family="monospace" font-size="6" text-anchor="middle">H.DER</text>
    <text x="138" y="110" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">CUELLO</text>`,

  "cabeza-hombros-inversos": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <polyline points="10,42 32,90 55,58 85,126 115,58 138,90 162,44 190,22 215,12" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="55" y1="58" x2="215" y2="52" stroke="#00d4ff" stroke-width="1.5" stroke-dasharray="6,3"/>
    <circle cx="85" cy="126" r="3.5" fill="#00e676"/>
    <circle cx="32" cy="90" r="2.5" fill="#00e676" opacity=".7"/>
    <circle cx="138" cy="90" r="2.5" fill="#00e676" opacity=".7"/>
    <line x1="190" y1="22" x2="218" y2="8" stroke="#00e676" stroke-width="2"/>
    <polygon points="218,8 210,18 222,16" fill="#00e676"/>
    <line x1="188" y1="12" x2="252" y2="12" stroke="#00e676" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <text x="85" y="138" fill="#00e676" font-family="monospace" font-size="7" text-anchor="middle">CABEZA</text>
    <text x="32" y="100" fill="#6a7a8a" font-family="monospace" font-size="6" text-anchor="middle">H.IZQ</text>
    <text x="138" y="100" fill="#6a7a8a" font-family="monospace" font-size="6" text-anchor="middle">H.DER</text>
    <text x="138" y="42" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">CUELLO</text>`,

  "cuna-ascendente": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <line x1="20" y1="115" x2="168" y2="30" stroke="#f5a623" stroke-width="1.5"/>
    <line x1="20" y1="135" x2="168" y2="62" stroke="#f5a623" stroke-width="1.5"/>
    <polyline points="20,128 40,115 60,108 80,98 100,90 120,82 140,75 158,65" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="168" y1="55" x2="215" y2="102" stroke="#ff3355" stroke-width="2"/>
    <polygon points="215,102 205,95 207,106" fill="#ff3355"/>
    <line x1="168" y1="100" x2="252" y2="100" stroke="#ff3355" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <text x="90" y="50" fill="#f5a623" font-family="monospace" font-size="7" text-anchor="middle">CUÑA ASCENDENTE</text>`,

  "cuna-descendente": `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <line x1="20" y1="28" x2="168" y2="82" stroke="#f5a623" stroke-width="1.5"/>
    <line x1="20" y1="50" x2="168" y2="110" stroke="#f5a623" stroke-width="1.5"/>
    <polyline points="20,35 40,50 60,55 80,64 100,68 120,75 140,80 158,88" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="168" y1="92" x2="215" y2="45" stroke="#00e676" stroke-width="2"/>
    <polygon points="215,45 206,55 218,53" fill="#00e676"/>
    <line x1="168" y1="45" x2="252" y2="45" stroke="#00e676" stroke-width="1" stroke-dasharray="5,3" opacity=".7"/>
    <text x="90" y="100" fill="#f5a623" font-family="monospace" font-size="7" text-anchor="middle">CUÑA DESCENDENTE</text>`,

  triangulo: `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <line x1="15" y1="25" x2="168" y2="74" stroke="#00d4ff" stroke-width="1.5"/>
    <line x1="15" y1="120" x2="168" y2="74" stroke="#00d4ff" stroke-width="1.5"/>
    <polyline points="15,30 36,108 58,45 82,98 108,58 132,82 152,72 168,74" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="168" y1="74" x2="208" y2="40" stroke="#00e676" stroke-width="2"/>
    <polygon points="208,40 200,50 212,48" fill="#00e676"/>
    <line x1="168" y1="74" x2="208" y2="110" stroke="#ff3355" stroke-width="2"/>
    <polygon points="208,110 198,102 206,100" fill="#ff3355"/>
    <text x="208" y="36" fill="#00e676" font-family="monospace" font-size="7" text-anchor="start">AL ALZA</text>
    <text x="208" y="124" fill="#ff3355" font-family="monospace" font-size="7" text-anchor="start">A LA BAJA</text>
    <text x="90" y="140" fill="#00d4ff" font-family="monospace" font-size="8" text-anchor="middle">TRIÁNGULO</text>`,

  rectangulo: `
    <rect width="260" height="148" fill="#07080f"/>
    <line x1="0" y1="148" x2="260" y2="0" stroke="#1c2240" stroke-width=".4" opacity=".4"/>
    <rect x="20" y="35" width="162" height="72" fill="#00d4ff" opacity=".04"/>
    <line x1="20" y1="35" x2="185" y2="35" stroke="#00d4ff" stroke-width="1.5"/>
    <line x1="20" y1="107" x2="185" y2="107" stroke="#00d4ff" stroke-width="1.5"/>
    <polyline points="20,90 45,38 70,96 95,40 120,100 145,38 170,90 182,72" fill="none" stroke="#6a7a8a" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="185" y1="35" x2="228" y2="12" stroke="#00e676" stroke-width="2"/>
    <polygon points="228,12 219,22 231,20" fill="#00e676"/>
    <line x1="185" y1="107" x2="228" y2="130" stroke="#ff3355" stroke-width="2"/>
    <polygon points="228,130 218,122 226,120" fill="#ff3355"/>
    <text x="95" y="26" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">RESISTENCIA</text>
    <text x="95" y="120" fill="#00d4ff" font-family="monospace" font-size="7" text-anchor="middle">SOPORTE</text>`,
};

export const PatronDiagrama = ({ id, className = "" }) => {
  const content = SVGS[id] || "";
  return (
    <svg
      viewBox="0 0 260 148"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      className={className}
      style={{ width: "100%", height: "auto", display: "block" }}
      dangerouslySetInnerHTML={{ __html: content }}
      data-testid={`patron-svg-${id}`}
    />
  );
};

export default PatronDiagrama;
